/**
 * Accordion (audio) block: vanilla JS, no jQuery.
 * Deep link: hash id matches `.accordion-audio__item` id (see PHP).
 */

function closeOtherPanels(root, exceptPanel) {
  root.querySelectorAll(".accordion-audio__panel").forEach((panel) => {
    if (panel === exceptPanel) {
      return;
    }
    panel.setAttribute("aria-hidden", "true");
    const labelledBy = panel.getAttribute("aria-labelledby");
    if (labelledBy) {
      const btn = root.querySelector(`#${CSS.escape(labelledBy)}`);
      if (btn) {
        btn.setAttribute("aria-expanded", "false");
      }
    }
  });
}

function openAccordionTrigger(trigger, { scroll = false } = {}) {
  const root = trigger.closest("[data-accordion-audio]");
  if (!root) {
    return;
  }
  const panelId = trigger.getAttribute("aria-controls");
  if (!panelId) {
    return;
  }
  const panel = root.querySelector(`#${CSS.escape(panelId)}`);
  if (!panel) {
    return;
  }
  closeOtherPanels(root, panel);
  trigger.setAttribute("aria-expanded", "true");
  panel.setAttribute("aria-hidden", "false");
  if (scroll) {
    const item = trigger.closest(".accordion-audio__item");
    if (item) {
      requestAnimationFrame(() => {
        item.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }
}

function toggleAccordionTrigger(trigger) {
  const root = trigger.closest("[data-accordion-audio]");
  if (!root) {
    return;
  }
  const panelId = trigger.getAttribute("aria-controls");
  if (!panelId) {
    return;
  }
  const panel = root.querySelector(`#${CSS.escape(panelId)}`);
  if (!panel) {
    return;
  }
  const expanded = trigger.getAttribute("aria-expanded") === "true";
  if (expanded) {
    trigger.setAttribute("aria-expanded", "false");
    panel.setAttribute("aria-hidden", "true");
  } else {
    openAccordionTrigger(trigger, { scroll: false });
  }
}

function initAccordionAudioRoot(root) {
  root.querySelectorAll("[data-accordion-audio-trigger]").forEach((btn) => {
    btn.addEventListener("click", () => toggleAccordionTrigger(btn));
  });
}

function applyAccordionAudioHash() {
  const raw = window.location.hash ? window.location.hash.slice(1) : "";
  if (!raw) {
    return;
  }

  let el = document.getElementById(raw);
  if (!el) {
    return;
  }

  const item = el.classList.contains("accordion-audio__item")
    ? el
    : el.closest(".accordion-audio__item");
  if (!item) {
    return;
  }

  const trigger = item.querySelector("[data-accordion-audio-trigger]");
  if (!trigger) {
    return;
  }

  openAccordionTrigger(trigger, { scroll: true });
}

function bootAccordionAudio() {
  document.querySelectorAll("[data-accordion-audio]").forEach((root) => {
    initAccordionAudioRoot(root);
  });
  applyAccordionAudioHash();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootAccordionAudio);
} else {
  bootAccordionAudio();
}

window.addEventListener("hashchange", applyAccordionAudioHash);
